module.exports = __webpack_public_path__ + "022df8e8e9614e1512a0c64293e521f3.svg";